module.exports = __webpack_public_path__ + "static/img/avator-wisely.8f571416.png";